import React from 'react';
import { QueryKey } from 'react-query';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterInvoiceProcessingJobStatusValue,
  UniversalFilterInvoiceProcessingJobStatusModes,
  UniversalFilterInvoiceProcessingJobStatusOnChange,
  UniversalFilterInvoiceProcessingJobStatusFilterOptions
} from './UniversalFilterInvoiceProcessingJobStatus.types';

import { useUniversalFilterInvoiceProcessingJobStatus } from './hooks/useUniversalFilterInvoiceProcessingJobStatus';

import { InvoiceProcessingJobsStatusesMultiSelect } from '../../../../../main/invoiceProcessingJobs/components/helpers/InvoiceProcessingJobsStatusesMultiSelect';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';

interface UniversalFilterInvoiceProcessingJobStatusProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterInvoiceProcessingJobStatusValue;
  i18nName: I18nText;
  autoFocus?: boolean;
  onChange: UniversalFilterInvoiceProcessingJobStatusOnChange;
  options?: UniversalFilterInvoiceProcessingJobStatusFilterOptions;
}

function UniversalFilterInvoiceProcessingJobStatus({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  autoFocus,
  onChange,
  options
}: UniversalFilterInvoiceProcessingJobStatusProps) {
  const { modeOptions, filterState, handleModeChange, handleStatusesChange } =
    useUniversalFilterInvoiceProcessingJobStatus({
      filterStateCacheKey,
      filterValue,
      onChange
    });

  return (
    <UniversalFilterTemplate<UniversalFilterInvoiceProcessingJobStatusModes>
      filterView={filterView}
      i18nName={i18nName}
      selectedMode={filterState.mode}
      modeOptions={modeOptions}
      onModeChange={handleModeChange}
    >
      <InvoiceProcessingJobsStatusesMultiSelect
        key={filterState.mode}
        value={filterState.statuses || []}
        autoFocus={autoFocus}
        onChange={handleStatusesChange}
        availableStatuses={options?.availableStatuses}
      />
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterInvoiceProcessingJobStatus;
